function t(n, i, g, l) {
  if (n === i) {
    const x = g.length - n.length;
    return Math.max(0, Math.min(l - x, i.length));
  }
  const e = n.length, c = i.length, f = Math.min(e, c);
  let h = 0;
  for (; h < f && n[h] === i[h]; )
    h += 1;
  let s = 0;
  const u = f - h;
  for (; s < u && n[e - 1 - s] === i[c - 1 - s]; )
    s += 1;
  return c - s;
}
export {
  t as getCursorPosition
};
